export default __webpack_public_path__ + "static/media/faq.a966313a.svg";